import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { Error } from "../Error/Error";
import { APIContext } from "../../store/APIStore";
import FdButton from "../UIComponents/Button/FdButton";

interface Props {
  featureName: string;
}

const PortalV2Only = ({ featureName }: Props) => {
  const api = useContext(APIContext);

  return (
    <Error heading={`${featureName} is available in fdPortal v2 only`}>
      <Typography>
        If this event was created just now, it may take a moment to appear in v2.
      </Typography>
      <Box>
        <FdButton
          variant="contained"
          color="primary"
          size="medium"
          onClick={() => window.open(api?.portalV2Url, "_blank", "noopener,noreferrer")}
          ButtonName="Open Portal v2"
          style={{ marginTop: "20px" }}
        />
      </Box>
    </Error>
  );
};

export default PortalV2Only;
